import styled from "styled-components";

export const LogoImage = styled.img`
    max-width: 250px;
`;